
<div class="content" role="main">
  <div class="container">

    <div class="makeABookingText">
      <div class="title">Please make a booking</div>
      <div class="diagnostics">
        <p-togglebutton [(ngModel)]="DiagnosticMode" onLabel="Diagnostics On" offLabel="Diagnostics Off" offIcon="pi pi-times" onIcon="pi pi-check" (click)="getAvailability()">
        </p-togglebutton>
      </div>
    </div>

    <div class="clr"></div>

    <div class="packageSelection">
      <div class="PackageSelectLabel">
        Select Package:
      </div>
      <div class="packageSelect" >
        <select class="dropDownList" name="ddlPackage" id="ddlPackage" (change)="onPackageSelect($event.target.value)">
          <option value="0">Select a package</option>
          @for (c of packages; track c) {
            <option value="{{c.packageId}}">{{c.name}}</option>
          }
        </select>
      </div>
    </div>

    <div class="clr"></div>

    <div class="packageSelection">
      <div class="PackageSelectLabel">
        Select Date:
      </div>
      <div class="packageSelect" >
        <input class="dropDownList" id="txtDate" type="date" (click)="dateChange()" />
      </div>
    </div>

    <div class="clr"></div>

    @for (a of (PackageAdmissions); track a) {
      <div class="packageSelection clr">
        <div class="PackageSelectLabel">
          Number of {{a.name}}:
        </div>
        <div class="packageSelect" >
          <p-inputnumber [(ngModel)]="SelectedAdmissions[a.index].noOfPeople" [id]="'ad'+a.name" [showButtons]="true" max="{{a.max}}" min="{{a.min}}" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="numberChange()"></p-inputnumber>
        </div>
      </div>
    }

    <div class="clr"></div>


    <div class="packageSelection">
      <div class="PackageSelectLabel">

      </div>
      <div class="packageSelect" >
        <input class="gaButton" id="btnGetAvailability" type="button" value="Get Availability" (click)="getAvailability()" />
      </div>

      <div class="clr"></div>
      <br>

        @if (DiagnosticMode) {
          <table class="table table-striped tableWidth">
            @for (st of (startTimes); track st) {
              <tr>
                @if (!st.timeAvailable) {
                  <td style='background-color: pink;' class="listTime">{{ st.time | date:'HH:mm' }}</td>
                }
                @if (st.timeAvailable) {
                  <td class="listTime">{{ st.time | date:'HH:mm' }}</td>
                }
                @if (st.timeAvailable) {
                  <td class="listQuantity">{{ st.quantityRemaining }}</td>
                }
                @if (!st.timeAvailable) {
                  <td style='background-color: pink;' class="listQuantity">{{ st.quantityRemaining }}</td>
                }
                @if (st.timeAvailable) {
                  <td class="listReason">{{ st.reason }}</td>
                }
                @if (!st.timeAvailable) {
                  <td style='background-color: pink;' class="listReason">{{ st.reason }}</td>
                }
                @if (st.timeAvailable) {
                  <td class="listBook">Resource: {{st.resourceName}}</td>
                }
                @if (!st.timeAvailable) {
                  <td style='background-color: pink;' class="listBook">Resource: {{st.resourceName}}</td>
                }
                @if (st.timeAvailable) {
                  <td class="listBook">Resource length: {{st.resourceLength}}</td>
                }
                @if (!st.timeAvailable) {
                  <td style='background-color: pink;' class="listBook">Resource length: {{st.resourceLength}}</td>
                }
              </tr>
            }
          </table>
        }

        @if (!DiagnosticMode) {
          <div class="timeContainer">
            @for (st of (startTimesFiltered); track st) {
              <div class="times">
                <input type=button class='bookButtonND' value="{{ st.time | date:'HH:mm' }}" id='btnbook' (click)="bookSlot(st.time)">
              </div>
            }
          </div>
        }
      </div>
    </div>

    <router-outlet></router-outlet>
